/* Productkaart v2 — maat-klik werkt prijs/voorraad/link bij (event-delegation; ook voor ajax-grids). Lichtgewicht. */
(function(){
  function splitMoney(mp){ var i = mp.lastIndexOf(','); return i >= 0 ? [mp.slice(0, i), mp.slice(i)] : [mp, '']; }
  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('button[data-pc-size]'); if(!btn) return;
    var card = btn.closest('.pc'); if(!card) return;
    e.preventDefault(); e.stopPropagation();
    card.querySelectorAll('button[data-pc-size]').forEach(function(b){ b.classList.remove('is-active'); b.removeAttribute('aria-pressed'); });
    btn.classList.add('is-active'); btn.setAttribute('aria-pressed','true');
    if(btn.dataset.price){
      var p = splitMoney(btn.dataset.price);
      var mainEl = card.querySelector('[data-pc-price-main]'); if(mainEl) mainEl.innerHTML = p[0];
      var centsEl = card.querySelector('[data-pc-price-cents]'); if(centsEl) centsEl.textContent = p[1];
    }
    var link = card.querySelector('.pc__link'); if(link && btn.dataset.url) link.setAttribute('href', btn.dataset.url);
    var badge = card.querySelector('.pc__badge');
    if(badge){
      var avail = btn.dataset.available === 'true';
      badge.classList.remove('pc__badge--low');
      badge.classList.toggle('pc__badge--out', !avail);
      var sl = (btn.dataset.scarceLabel || '').trim();
      badge.classList.toggle('pc__badge--schaars', avail && !!sl);
      var label = badge.querySelector('span:last-child');
      if(label) label.textContent = !avail ? 'Uitverkocht' : (sl || 'Op voorraad');
    }
  }, true);
})();
